import type { FaireProductEntity } from "../../entity_types/product";

export const p_nt87hp69rw: FaireProductEntity = {
  token: "p_nt87hp69rw",
  type: "product",
  name: "Thank You for Your Kindness Greeting Card",
  brandToken: "b_u2g9n98tba",
  brandName: "Goods for the Study",
  imageUrl:
    "https://cdn.faire.com/fastly/05440000a8fe5eede8775b69c818e3978a0414ffd7bbdfba32ae1d43d54d9bdb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef22ea467c78dcd5f030ce3532993a1d3d6c8d77e9fdba2342a72c1d32bb13bb.jpeg",
    "https://cdn.faire.com/fastly/642113bec87aec8d7fdffc3fd04e829d584a8a261e3b0e6dca86adaa914fa1f0.jpeg",
    "https://cdn.faire.com/fastly/c5a76e54e84a97ec836196fc12f181ddda157ba80c910805debcfd23e9af2d8d.jpeg",
  ],
  priceDollars: 3.47,
  description:
    'Gorgeous letterpressed greeting cards that are perfect for sending a meaningful message . Featuring 270gsm card stock with a corresponding green envelope.\n\nMeasures 3.5" x 4.875"\n',
  tags: [],
  msrpDollars: 6.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:47.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
